import { useState, useRef, useContext } from 'react';
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import airports from "../../Data/AirportList.json";
import { Link, useNavigate } from 'react-router-dom';
import './Flight.css';
import DefaultData from '../../CompanyData/DefaultData';
import { LandingContext } from '../Profile/LandingContext'; // 2. Import the context 

const FlightSearchPanel = () => {
    const navigate = useNavigate();
    const landingData = useContext(LandingContext);
    const [departureDate, setDepartureDate] = useState(new Date())
    const [returnDate, setReturnDate] = useState(new Date())
    const [departureResults, setDepartureResults] = useState([]);
    const [arrivalResults, setArrivalResults] = useState([]);
    const [locationFrom, setLocationFrom] = useState('HYD');
    const [locationTo, setLocationTo] = useState('BOM');
    const [displayFrom, setDisplayFrom] = useState('Hyderabad(HYD), India');
    const [displayTo, setDisplayTo] = useState('Mumbai(BOM), India');
    const [selectedDeparture, setSelectedDeparture] = useState(null);
    const [selectedArrival, setSelectedArrival] = useState(null);
    const [cityFrom, setCityFrom] = useState('Hyderabad');
    const [cityTo, setCityTo] = useState('Mumbai');
    const [from, setFrom] = useState('Hyderabad, India');
    const [to, setTo] = useState('Mumbai, India');
    const [trips, setTrips] = useState([
        { from: "HYD, India", to: "BOM, India", locationFrom: "HYD", locationTo: "BOM", displayFrom: "Hyderabad(HYD)", displayTo: "Mumbai(BOM)", cityFrom: "Hyderabad", cityTo: "Mumbai", departureDate: new Date(), departureResults: [], arrivalResults: [] },
    ]);
    const [adults, setAdults] = useState(1);
    const [kids, setKids] = useState(0);
    const [infants, setInfants] = useState(0);
    const [cabinClass, setCabinClass] = useState("ECONOMY");
    const [preffered, setPreferred] = useState("REGULAR");
    const [isDirect, setIsDirect] = useState(false);
    const [isConnecting, setIsConnecting] = useState(false);
    const [errors, setErrors] = useState({});
    const [isDomestic, setIsDomestic] = useState('DOMESTIC');
    const [journeyType, setJourneyType] = useState("ONEWAY");
    const inputDRef = useRef(null);
    const inputARef = useRef(null);

    const validate = () => {
        let temp = {};
        temp.from = from === "" ? false : true;
        temp.to = to === "" ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x === true);
    };
    const handleDepartureAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayFrom(value);
        if (value.length > 0) {
            const lowerValue = value.toLowerCase();
            const filteredAirports = airports.filter(airport => airport.display === true && airport.airportCode.toLowerCase().includes(value.toLowerCase())).slice(0, 10);
            setDepartureResults(filteredAirports);
            if (filteredAirports.length === 0) {
                const filteredAirports1 = airports
                    .filter(airport =>
                        airport.airportCode.toLowerCase().includes(lowerValue) ||
                        airport.cityName.toLowerCase().includes(lowerValue) ||
                        airport.airportName.toLowerCase().includes(lowerValue) &&
                        (!selectedArrival || airport.airportCode !== selectedArrival.airportCode) // Exclude selected arrival
                    )
                    .slice(0, 10);
                setDepartureResults(filteredAirports1);
            }
        } else {
            setDepartureResults([]);
        }
    };
    const handleDepartureAirportClick = (e) => {
        setArrivalResults([]);
        let filteredAirports = airports.filter(function (p) {
            return p.display === true
        }).slice(0, 10);
        setDepartureResults(filteredAirports);
        inputDRef.current.select();
    };
    const handleDepartureSelect = (data) => {
        if (selectedArrival && selectedArrival.airportCode === data.airportCode) {
            alert("Departure and arrival airports cannot be the same.");
            setSelectedArrival(null);
            setDisplayTo(""); // Clear arrival input
            return;
        } else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayFrom(DF);
            setLocationFrom(data.airportCode)
            setCityFrom(data.cityName);
            setFrom(data.cityName);
            setSelectedDeparture(data);
            setDepartureResults([]);
        }
    }
    const handleArrivalAirportSearch = (e) => {
        const value = e.target.value;
        setDisplayTo(value);
        if (value.length > 0) {
            const lowerValue = value.toLowerCase();
            const filteredAirports = airports
                .filter(airport =>
                    airport.airportCode.toLowerCase().includes(lowerValue) ||
                    airport.cityName.toLowerCase().includes(lowerValue) ||
                    airport.airportName.toLowerCase().includes(lowerValue)
                )
                .slice(0, 10);
            setArrivalResults(filteredAirports);
            if (filteredAirports.length === 0) {
                const filteredAirports1 = airports
                    .filter(airport =>
                        airport.cityName.toLowerCase().includes(value.toLowerCase())
                    )
                    .slice(0, 10);
                setArrivalResults(filteredAirports1);
            }
        } else {
            setArrivalResults([]);
        }
    };
    const handleArrivalSelect = (data) => {
        if (selectedDeparture && selectedDeparture.airportCode === data.airportCode) {
            alert("Arrival and departure airports cannot be the same.");
            setSelectedDeparture(null);
            setDisplayFrom(""); // Clear departure input
            return;
        }
        else {
            var DF = data.cityName + "(" + data.airportCode + "), " + data.countryName;
            setDisplayTo(DF);
            setLocationTo(data.airportCode)
            setCityTo(data.cityName);
            setTo(data.cityName);
            setSelectedArrival(data);
            setArrivalResults([]);
        }
    }
    const handleArrivalAirportClick = (e) => {
        setDepartureResults([]);
        let filteredAirports = airports.filter(function (p) {
            return p.display === true
        }).slice(0, 10);
        setArrivalResults(filteredAirports);
        inputARef.current.select();
    };
    const handleClassType = (e) => {
        setCabinClass(e.target.value)
    }
    const handleDirectType = (e) => {
        setIsDirect(e.target.checked)
    }
    const handleConnectingType = (e) => {
        setIsConnecting(e.target.checked)
    }
    const handlePrefferedType = (e) => {
        setPreferred(e.target.value)
    }
    const handleIncreaseAdults = (e) => {
        e.stopPropagation();
        setAdults(parseFloat(adults + 1))
    }
    const handleDecreaseAdults = (e) => {
        e.stopPropagation();
        if (adults !== 1) {
            setAdults(parseFloat(adults - 1))
        }
    }
    const handleIncreaseKids = (e) => {
        e.stopPropagation();
        setKids(parseFloat(kids + 1))
    }
    const handleDecreaseKids = (e) => {
        e.stopPropagation();
        if (kids !== 0) {
            setKids(parseFloat(kids - 1))
        }
    }
    const handleIncreaseInfants = (e) => {
        e.stopPropagation();
        setInfants(parseFloat(infants + 1))
    }
    const handleDecreaseInfants = (e) => {
        e.stopPropagation();
        if (infants !== 0) {
            setInfants(parseFloat(infants - 1))
        }
    }
    const handleDepartureDate = (date) => {
        const selectedDate = date[0];
        setDepartureDate(selectedDate);

        // If returnDate is before the new departureDate, reset it to departureDate
        if (returnDate && selectedDate && returnDate < selectedDate) {
            setReturnDate(selectedDate);
        }
    };
    const handleReturnDate = (date) => {
        setReturnDate(date[0]);
    };
    const handleJourneyType = (e, type) => {
        e.preventDefault();
        setJourneyType(type)
    }
    function GetFlightDestinations() {
        const fvalues = [];
        for (var i = 0; i < trips.length; i++) {
            fvalues.push({ from: locationFrom, to: locationTo, departureDate: moment(departureDate).format('YYYY-MM-DD'), returnDate: moment(returnDate).format('YYYY-MM-DD') });
        }
        return fvalues;
    }
    const handleSearch = (e) => {
        e.preventDefault();
        if (validate()) {
            const searchQuery = {
                "journeyType": journeyType,
                "isDomestic": isDomestic,
                "adults": adults,
                "kids": kids,
                "infants": infants,
                "cabinClass": cabinClass,
                "companyId": DefaultData.DEFAULTCOMPANYID,
                "preferred": preffered,
                "isDirectFlight": isDirect,
                "isConnectingFlight": isConnecting,
                "flightTravelerPoints": GetFlightDestinations(),
            }
            console.log(searchQuery);
            navigate('/flight/' + adults + "/" + kids + "/" + infants + "/" + isDomestic, { state: { searchQuery } });
        }
    }
     const searchButtonStyle = {
        backgroundColor: DefaultData?.THEMECOLOR1, // Use theme color, fallback to default purple
        borderColor: DefaultData?.THEMECOLOR1, // Also set border color for consistency
    };
    const panelContainerStyle = {
        '--active-tab-color': DefaultData?.THEMECOLOR1,
         '--form-check-active-color': landingData?.themeColor1 || DefaultData?.THEMECOLOR1
    };

    return (
    <div className="search-flight-panel-container" style={panelContainerStyle}>
        <div className="card-body p-0">
            <div className="row">
                <div className="col-12">
                   <ul className="nav nav-pills arrow-navtabs nav-success mb-3" role="tablist">
                        <li className="nav-item me-2" role="presentation">
                            <Link className={journeyType === "ONEWAY" ? "nav-link active" : "nav-link bg-light"} name="ONEWAY" onClick={(e) => handleJourneyType(e, "ONEWAY")} to="#">
                                ONEWAY
                            </Link>
                        </li>
                        <li className="nav-item me-2" role="presentation">
                            <Link className={journeyType === "RETURN" ? "nav-link active" : "nav-link bg-light"} name="RETURN" onClick={(e) => handleJourneyType(e, "RETURN")} to="#">
                                ROUNDTRIP
                            </Link>
                        </li>
                    </ul>
                    </div>
                </div>
                <div className="row g-3 align-items-end"> {/* Using g-3 for slightly more space */}
                    <div className="col">
                        <label htmlFor="fromInput" className="form-label">FROM</label>
                        <div className="form-icon position-relative">
                            <input ref={inputDRef} id="fromInput" className="form-control form-control-icon" type="text" placeholder="From" value={displayFrom} onChange={handleDepartureAirportSearch} onClick={handleDepartureAirportClick} onFocus={handleDepartureAirportClick} />
                            <i className="ri-flight-takeoff-line text-black" />
                        </div>
                        {errors.from === false && (<div className="validationerror">Please select departure</div>)}
                        {departureResults.length > 0 && (
                            <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                                {departureResults.map((airport) => (
                                    <li className="locationListVideoItem" key={airport.airportCode} onClick={() => handleDepartureSelect(airport)}>
                                        <div className="item-name">{airport.cityName} ({airport.airportCode})</div>
                                        <div className="item-details">
                                            <span className="item-code-date">{airport.airportName}, </span>
                                            <span className="item-designation">{airport.countryName}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="col">
                        <label htmlFor="toInput" className="form-label">TO</label>
                        <div className="form-icon position-relative">
                            <input ref={inputARef} id="toInput" className="form-control searchTextbox" type="text" placeholder="To" value={displayTo} onChange={handleArrivalAirportSearch} onClick={handleArrivalAirportClick} onFocus={handleArrivalAirportClick} />
                            <i className="ri-flight-land-line text-black" />
                        </div>
                        {arrivalResults.length > 0 && (
                            <ul className="locationListVideo scrollable-list" style={{ minWidth: "350px" }}>
                                {arrivalResults.map((airport) => (
                                    <li className="locationListVideoItem" key={airport.airportCode} onClick={() => handleArrivalSelect(airport)}>
                                        <div className="item-name">{airport.cityName} ({airport.airportCode})</div>
                                        <div className="item-details">
                                            <span className="item-code-date">{airport.airportName}</span>
                                            <span className="item-designation">{airport.countryName}</span>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="col">
                        <label htmlFor="departureDate" className="form-label">DEPARTURE DATE</label>
                        <div className="input-group">
                            <Flatpickr
                                value={departureDate}
                                onChange={handleDepartureDate}
                                options={{ dateFormat: "d M Y", minDate: "today" }}
                                className={"form-control"}
                                placeholder="DEPARTURE DATE"
                            />
                            <div className="input-group-text bg-primary border-primary text-white">
                                <i className="ri-calendar-2-line"></i>
                            </div>
                        </div>
                    </div>
                    {journeyType === "RETURN" && (
                        <div className="col">
                            <label htmlFor="returnDate" className="form-label">RETURN DATE</label>
                            <div className="input-group">
                                <Flatpickr
                                    value={returnDate}
                                    onChange={handleReturnDate}
                                    options={{ dateFormat: "d M Y", minDate: departureDate }}
                                    className={"form-control"}
                                    placeholder="RETURN DATE"
                                />
                                <div className="input-group-text bg-primary border-primary text-white">
                                    <i className="ri-calendar-2-line"></i>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className="col-lg-3">
                        <label htmlFor="travellersInput" className="form-label">TRAVELLERS & CLASS</label>
                        <div className="dropdown" data-bs-auto-close="outside">
                            <div className="form-control w-100 dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                                {`${adults} Adults, ${kids} Kids, ${infants} Infants & ${cabinClass}`}
                            </div>
                            <div className="dropdown-menu p-3" aria-labelledby="dropdownMenuButton" style={{width: '300px'}}>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Adults</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseAdults}>–</button>
                                        <input type="number" className="product-quantity text-center" min="1" max="9" readOnly value={adults} name="adults" />
                                        <button type="button" className="plus" onClick={handleIncreaseAdults}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Kids</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseKids}>–</button>
                                        <input type="number" className="product-quantity text-center" min="0" max="9" readOnly value={kids} name="kids" />
                                        <button type="button" className="plus" onClick={handleIncreaseKids}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3 d-flex justify-content-between align-items-center">
                                    <span>Infants</span>
                                    <div className="input-step d-flex align-items-center">
                                        <button type="button" className="minus" onClick={handleDecreaseInfants}>–</button>
                                        <input type="number" className="product-quantity text-center" min="0" max="5" readOnly value={infants} name="infants" />
                                        <button type="button" className="plus" onClick={handleIncreaseInfants}>+</button>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <select className="form-select" value={cabinClass} onChange={handleClassType}>
                                        <option value="ECONOMY">ECONOMY</option>
                                        <option value="PREMIUM_ECONOMY">PREMIUM ECONOMY</option>
                                        <option value="BUSINESS">BUSINESS</option>
                                        <option value="FIRST">FIRST</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-auto">
                        <button 
                        type="button" 
                        onClick={handleSearch} 
                        className="w-100 btn btn-search"
                        style={searchButtonStyle}
                    >
                        Search
                    </button>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="REGULAR" onChange={handlePrefferedType} value="REGULAR" checked={preffered === "REGULAR"} />
                            <label className="form-check-label" htmlFor="REGULAR">REGULAR</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="STUDENT" onChange={handlePrefferedType} value="STUDENT" checked={preffered === "STUDENT"} />
                            <label className="form-check-label" htmlFor="STUDENT">STUDENT</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" name="preffered" id="CORPORATE" onChange={handlePrefferedType} value="CORPORATE" checked={preffered === "CORPORATE"} />
                            <label className="form-check-label" htmlFor="CORPORATE">CORPORATE</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="isDirect" id="isDirect" onChange={handleDirectType} checked={isDirect} />
                            <label className="form-check-label" htmlFor="isDirect">DIRECT FLIGHT?</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="checkbox" name="isConnecting" id="isConnecting" onChange={handleConnectingType} checked={isConnecting} />
                            <label className="form-check-label" htmlFor="isConnecting">CONNECTING FLIGHT?</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlightSearchPanel;